import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigurationService, DashboardContext, DashboardDialogService, DialogService, HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { TransportDetails } from 'src/tmc-yard/components/transport-details/transport-details-model';
import { TransportStationAssignment } from '../../../widgets/control/sac-client/model/sac-client.model';
import { environment } from 'src/environments/environment';
import { Station } from 'src/tmc-yard/client/model/station';
import { Transport } from 'src/tmc-yard/common/model/transport.model';

@Component({
  selector: 'app-resend-message-action',
  templateUrl: './resend-message-action.component.html',
  styleUrls: ['./resend-message-action.component.scss']
})
export class ResendMessageActionComponent {

  @Input() disabled = false;

  @Input() transport: Transport;

  @Input() station: Station;

  @Input() asButton = false;

  @Output() onChange = new EventEmitter();

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService,
    private configurationService: ConfigurationService,
    private httpService: HttpService
  ) { }

  clickButton() {


    this.dialogService.showConfirm(
      'tmc-yard.widgets.sac-client.call-transport-to-station.confirm-dialog.title',
      'tmc-yard.widgets.sac-client.call-transport-to-station.confirm-dialog.message'
    ).afterClosed().subscribe(confirm => {

      if (confirm) {

        const assignment = new TransportStationAssignment();
        assignment.transport = { id: this.transport.id };
        assignment.station = { id: this.station.id };

        this.httpService.postWithContext<any[]>(environment.sacClientEndpoint + '/call-transport', assignment).subscribe(
          response => {
            this.onChange.next();
          },
          error => {
            console.error(error);
          }
        );

      }

    });

  }
}

